var _style, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Laag_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 900 900"
    },
    xmlSpace: "preserve",
    viewBox: "73.65 294.49 755.94 309.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\n\t\t.st0{clip-path:url(#SVGID_00000045595025824203809380000000835375811668664195_);fill:url(#SVGID_00000081616908033380876230000015456660543586220181_);}\n\t\n\t\t.st1{clip-path:url(#SVGID_00000026149526036282178190000001584206934120488638_);fill:url(#SVGID_00000067930695071976615630000010205687424446347152_);}\n\t\n\t\t.st2{clip-path:url(#SVGID_00000144300605075690445690000012064953517693778344_);fill:url(#SVGID_00000093865128031570827900000008917837101501252758_);}\n\t\n\t\t.st3{clip-path:url(#SVGID_00000070813965490948762160000011337298260109430435_);fill:url(#SVGID_00000127766764548985357590000001033751337207034543_);}\n\t\n\t\t.st4{clip-path:url(#SVGID_00000011732986509103999530000017042215428770392718_);fill:url(#SVGID_00000118362972849486081040000012963115690382701214_);}\n\t\n\t\t.st5{clip-path:url(#SVGID_00000080903029098205789660000001711496917606577082_);fill:url(#SVGID_00000008829078650522597830000014120725646088499869_);}\n\t\n\t\t.st6{clip-path:url(#SVGID_00000092454113828401457950000007922736203406456460_);fill:url(#SVGID_00000096738968859921752260000008256868529330303423_);}\n\t\n\t\t.st7{clip-path:url(#SVGID_00000036968835535494256230000005463096912646867884_);fill:url(#SVGID_00000038396117038911323150000003883445620661426341_);}\n\t\n\t\t.st8{clip-path:url(#SVGID_00000123414578902529806880000009875939903116483971_);fill:url(#SVGID_00000134935373636973930590000011849690811634080958_);}\n\t.st9{fill:url(#SVGID_00000019649799156760675620000007019660205870201757_);}\n\t.st10{fill:url(#SVGID_00000099655369599686631810000006369923873151955630_);}\n\t.st11{fill:url(#SVGID_00000027584012666754834690000017575474708737578426_);}\n\t.st12{opacity:0.28;fill:url(#SVGID_00000040553185454021178050000016594897004208015540_);}\n\t.st13{opacity:0.28;fill:url(#SVGID_00000075120418926027579400000003324670283056248460_);}\n\t.st14{opacity:0.13;fill:url(#SVGID_00000049935286105450267000000011002358232022440631_);}\n\t.st15{opacity:0.36;fill:url(#SVGID_00000149341940934190978470000008012055888145760401_);}\n\t.st16{opacity:0.5;fill:url(#SVGID_00000114047261319346629050000001274711426662112958_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M810.62,510.18L807.04,499l-26.11,0.17l-3.44,11.23l-17.57,0.11l23.44-71.45l20.48-0.13l24.35,71.14     L810.62,510.18z M785.65,483.86l16.47-0.1l-8.4-26.12L785.65,483.86z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000036967294833164338960000007167005732552643469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040559279719466815950000009816227286895545474_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.6988,
    y1: 477.0468,
    x2: 828.0118,
    y2: 477.0468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 310.7,
    y: 434.55,
    style: {
      clipPath: "url(#SVGID_00000036967294833164338960000007167005732552643469_)",
      fill: "url(#SVGID_00000040559279719466815950000009816227286895545474_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000133491402953096511870000014993491220449781127_",
    d: "M730.41,511.16c-11.18,0.07-19.14-4.5-23.88-13.7     l13.9-8.24c1.22,2.17,2.55,3.72,4,4.66c1.44,0.94,3.44,1.4,5.98,1.39c6.09-0.04,9.12-2.88,9.08-8.51l-0.31-48.38l16.07-0.1     l0.31,48.38c0.05,7.61-2.27,13.58-6.97,17.92C743.91,508.92,737.85,511.11,730.41,511.16z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183229069572281114750000011039394329576755092_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000133491402953096511870000014993491220449781127_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011715864888875692110000002675640085833333122_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.006,
    y1: 476.0895,
    x2: 827.3191,
    y2: 476.0895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 310.01,
    y: 433.6,
    style: {
      clipPath: "url(#SVGID_00000183229069572281114750000011039394329576755092_)",
      fill: "url(#SVGID_00000011715864888875692110000002675640085833333122_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152224563099942360320000013754316842355361433_",
    d: "M672.88,494.72l28.12-0.18l0.1,15.68l-44.18,0.28     l-0.45-71.29l43.68-0.28l0.1,15.68l-27.61,0.18l0.07,11.81l25.1-0.16l0.1,15.48l-25.1,0.16L672.88,494.72z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118393238702719863980000016916747022450237062_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152224563099942360320000013754316842355361433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108294436106123089850000016811709643137703862_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.5139,
    y1: 476.3976,
    x2: 826.827,
    y2: 476.3976
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6806,
    style: {
      stopColor: "#00B49B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 309.51,
    y: 433.91,
    style: {
      clipPath: "url(#SVGID_00000118393238702719863980000016916747022450237062_)",
      fill: "url(#SVGID_00000108294436106123089850000016811709643137703862_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174596857184402905510000004990808364640994696_",
    d: "M627.66,439.12l16.07-0.1l0.45,71.29l-16.07,0.1     L627.66,439.12z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108306835980739883670000017556628271314347906_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174596857184402905510000004990808364640994696_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036233608871596809430000000394784889872977557_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.8212,
    y1: 476.1311,
    x2: 826.1342,
    y2: 476.1311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3592,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 308.82,
    y: 433.64,
    style: {
      clipPath: "url(#SVGID_00000108306835980739883670000017556628271314347906_)",
      fill: "url(#SVGID_00000036233608871596809430000000394784889872977557_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151522468078303545110000009900625029523107988_",
    d: "M409.14,439l16.06-0.1l0.45,71.29l-16.07,0.1     l-0.18-28.31l-22.09,0.14l0.18,28.31l-16.07,0.1l-0.45-71.29l16.07-0.1l0.17,27.29l22.09-0.14L409.14,439z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000008137905339890600350000014553282510152536457_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151522468078303545110000009900625029523107988_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154396882247595328960000016125632053855798178_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.0047,
    y1: 474.6,
    x2: 829.3178,
    y2: 474.6
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312,
    y: 432.11,
    style: {
      clipPath: "url(#SVGID_00000008137905339890600350000014553282510152536457_)",
      fill: "url(#SVGID_00000154396882247595328960000016125632053855798178_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000048462746161078090290000013080204427435980171_",
    d: "M364.23,438.96l0.1,15.68l-18.07,0.11l0.35,55.61     l-16.07,0.1l-0.35-55.61l-18.07,0.11l-0.1-15.68L364.23,438.96z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078025277604298262190000005796665496960593036_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048462746161078090290000013080204427435980171_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134965259776729359940000017355522010245214879_",
    gradientUnits: "userSpaceOnUse",
    x1: 312.277,
    y1: 474.2749,
    x2: 829.5901,
    y2: 474.2749
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 312.28,
    y: 431.78,
    style: {
      clipPath: "url(#SVGID_00000078025277604298262190000005796665496960593036_)",
      fill: "url(#SVGID_00000134965259776729359940000017355522010245214879_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000156578244512796503550000007172995103503582102_",
    d: "M452.98,494.72l28.11-0.18l0.1,15.68l-44.18,0.28     l-0.45-71.29l43.68-0.28l0.1,15.68l-27.61,0.18l0.08,11.81l25.1-0.16l0.1,15.48l-25.1,0.16L452.98,494.72z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023980473251090730210000015751225810203031174_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000156578244512796503550000007172995103503582102_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026159983095014676220000014196163424022225597_",
    gradientUnits: "userSpaceOnUse",
    x1: 311.312,
    y1: 474.9879,
    x2: 828.6251,
    y2: 474.9879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 311.31,
    y: 432.5,
    style: {
      clipPath: "url(#SVGID_00000023980473251090730210000015751225810203031174_)",
      fill: "url(#SVGID_00000026159983095014676220000014196163424022225597_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029044855686000209130000012323494341177532568_",
    d: "M548.62,500.93c-7.05,7.18-15.66,10.79-25.84,10.86     c-10.17,0.06-18.84-3.45-25.97-10.53c-7.14-7.08-10.74-15.85-10.81-26.31c-0.07-10.45,3.42-19.27,10.48-26.45     c7.05-7.17,15.66-10.79,25.84-10.86c10.17-0.07,18.83,3.45,25.97,10.53c7.14,7.08,10.74,15.86,10.81,26.31     C559.16,484.94,555.67,493.76,548.62,500.93z M508.04,490.09c3.94,3.91,8.82,5.85,14.65,5.81c5.82-0.04,10.68-2.04,14.57-6     c3.89-3.96,5.81-9.07,5.77-15.32c-0.04-6.25-2.03-11.33-5.97-15.24c-3.94-3.91-8.82-5.85-14.65-5.81     c-5.82,0.04-10.68,2.04-14.57,6c-3.89,3.96-5.82,9.07-5.78,15.31C502.1,481.1,504.09,486.17,508.04,490.09z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000098905774481059119360000012661141859941090435_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029044855686000209130000012323494341177532568_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015353109250384120720000015920464117952620733_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.8199,
    y1: 475.3972,
    x2: 828.1329,
    y2: 475.3972
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4322,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 310.82,
    y: 432.9,
    style: {
      clipPath: "url(#SVGID_00000098905774481059119360000012661141859941090435_)",
      fill: "url(#SVGID_00000015353109250384120720000015920464117952620733_)"
    },
    width: 517.31,
    height: 84.99
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067227970231129256460000016495118962313984920_",
    d: "M604.62,510.22l-13.4-23.34l-7.63,0.05l0.15,23.43     l-16.07,0.1l-0.45-71.29l28.11-0.18c6.69-0.04,12.4,2.3,17.11,7.02c4.72,4.72,7.1,10.48,7.14,17.27     c0.03,4.35-1.14,8.38-3.49,12.09c-2.35,3.72-5.46,6.6-9.33,8.67l15.13,26.08L604.62,510.22z M583.37,454.34l0.12,18.33     l12.05-0.08c2.21-0.01,4.09-0.91,5.66-2.68c1.56-1.77,2.34-3.95,2.32-6.53c-0.02-2.58-0.82-4.75-2.4-6.5     c-1.59-1.76-3.48-2.63-5.69-2.61L583.37,454.34z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070085480579305588000000017103866105453672328_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067227970231129256460000016495118962313984920_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063600829051658306830000015274032266637642628_",
    gradientUnits: "userSpaceOnUse",
    x1: 310.1271,
    y1: 475.7772,
    x2: 827.4402,
    y2: 475.7772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    style: {
      stopColor: "#009CFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9273,
    style: {
      stopColor: "#00CB38"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 310.13,
    y: 433.28,
    style: {
      clipPath: "url(#SVGID_00000070085480579305588000000017103866105453672328_)",
      fill: "url(#SVGID_00000063600829051658306830000015274032266637642628_)"
    },
    width: 517.31,
    height: 84.99
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163791083494579260960000003019915642193958301_",
    gradientUnits: "userSpaceOnUse",
    x1: 269.5036,
    y1: 446.5986,
    x2: 269.5036,
    y2: 623.443,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163791083494579260960000003019915642193958301_)"
    },
    d: "M104.12,580.46   c14.95,11.39,28.95,15.88,36.98,18.34c15.17,4.64,27.21,5.21,35.24,5.53c13.61,0.55,21.26-1,24.97-1.89   c1.64-0.39,6.74-1.68,12.65-4.21c26.61-11.42,40.53-35.78,42.25-38.89c4.69-8.46,7-15.44,8.73-21.8   c3.99-14.7,6.05-30.34,5.77-46.59l-1.67-86.72c-0.12-6.69,4.73-12.18,10.75-12.18h-1.85c-11.43,0.85-19.73,4.18-24.51,6.53   c-21.55,10.58-36.61,33.08-38.08,56.29c-0.46,7.22,0.49,13.12,1.24,16.67c-21.25,34.95-41.58,57.04-47.16,57.37   c-0.37,0.02-3.79,0.13-7.79,0.01c-2.08-0.06-4.22-0.19-6.88-0.66c-0.15-0.03-0.28-0.05-0.39-0.07c-1.57-0.3-4.37-0.86-7.68-2.34   c-3.81-1.7-6.34-3.75-7.82-4.97c-4.72-3.87-13.97-15.09-16.68-16.12c-5.97-2.26-46.65,24.18-48.11,29.69   c-1.9,7.19,2.77,14.28,8.9,23.58C89.67,568.2,97.37,575.32,104.12,580.46z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010997397718335486380000010606632318879823013_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.0226,
    y1: 561.1619,
    x2: 163.0235,
    y2: 335.6584,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010997397718335486380000010606632318879823013_)"
    },
    d: "M169.43,528.92   c5.59-0.1,16.24-1.15,26.37-8.14c23.27-16.05,20.93-47.59,20.79-49.23l0.33-15.27c0.97-33.47,31.31-64.21,63.3-64.21h4.73   c1.15,0,2.28-0.1,3.43-0.16V392h64.38V337.2c0-23.58-18.85-42.7-42.1-42.7h-30.13c-57.01,0-102.53,49.27-101.51,109.74   c0,0,1.85,100.04,1.33,104.97c-0.26,2.45-0.69,4.14-0.79,4.53c-0.56,2.15-1.27,3.81-1.91,5.29c-0.38,0.88-0.9,2.03-1.6,3.37   c-0.72,1.36-1.07,2.03-1.65,2.78c-1.31,1.7-2.62,2.55-2.95,2.76C170.66,528.44,169.94,528.74,169.43,528.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021821542972142621400000013128956344184012935_",
    gradientUnits: "userSpaceOnUse",
    x1: 348.7762,
    y1: 346.3012,
    x2: 221.588,
    y2: 349.5329,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021821542972142621400000013128956344184012935_)"
    },
    d: "M94.84,325.32v66.75h75.37   c0.87,0,1.74,0.13,2.53,0.39c3.53,1.14,6.14,4.62,6.21,8.72l0.03,1.01c0-37.57,18.01-70.54,45.42-89.82   c-7.85-5.53-16.47-9.88-25.63-12.92c-9.57-3.22-19.72-4.96-30.23-4.96h-43.33c-0.56,0-1.13,0.03-1.69,0.05   C107.55,295.44,94.84,308.88,94.84,325.32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062906078108022868230000014836594058771152786_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.3132,
    y1: 436.8851,
    x2: 298.9823,
    y2: 270.1674,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "url(#SVGID_00000062906078108022868230000014836594058771152786_)"
    },
    d: "M172.76,392.47   c3.51,1.14,6.12,4.61,6.19,8.71l0.06,3.06c-0.65-38.41,17.49-72.25,45.4-91.86c-7.84-5.52-16.48-9.89-25.64-12.92   C188.08,316.95,170.78,351.97,172.76,392.47z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143578795519465126980000009483348243968279732_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.1304,
    y1: 553.556,
    x2: 253.4333,
    y2: 363.1615,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "url(#SVGID_00000143578795519465126980000009483348243968279732_)"
    },
    d: "M169.43,528.92   c5.59-0.1,16.24-1.15,26.37-8.14c23.28-16.05,20.93-47.61,20.78-49.24l0.34-15.27c0.96-33.47,31.3-64.21,63.3-64.21   c0,0-58.46-4.17-72.28,60.28c-2.99,13.96-4.19,25.09-14.19,35.17c-4.7,4.74-9.78,7.41-13.35,8.92c0.06,4.53,0.06,6.6,0.04,7.63   c-0.01,0.64-0.04,1.98-0.04,2.94c0,0.11,0,0.54-0.01,1.11c0,0.19-0.01,0.52-0.02,0.79c-0.03,0.57-0.1,1.03-0.2,1.65   c-0.22,1.33-0.34,2-0.54,2.81c-0.21,0.84-0.4,1.45-0.58,1.99c-0.18,0.56-0.96,2.9-2.62,6.33c-0.24,0.49-0.37,0.74-0.5,1   c0,0-1.38,2.72-3.17,4.26c-0.57,0.49-1.2,0.9-1.2,0.9C171.06,528.16,170.35,528.57,169.43,528.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146460538429154490390000016673274494043916932_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.3914,
    y1: 628.8547,
    x2: 156.5338,
    y2: 380.7417,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.13,
      fill: "url(#SVGID_00000146460538429154490390000016673274494043916932_)"
    },
    d: "M199.32,602.71   c5.22-1.14,12.41-3.24,20.28-7.36c1.59-0.83,7.94-4.22,15.22-10.34c2.35-1.97,12.55-10.74,20.71-24.81   c2.84-4.9,4.63-9.06,5.3-10.65c0.77-1.83,2.33-5.75,4.15-12.36c1.09-3.97,3.17-12.17,4.5-23.01c0.77-6.3,1.37-14.16,1.22-23.24   c-0.56-28.91-1.12-57.81-1.67-86.72c-0.08-0.64-0.54-5,2.71-8.6c3.15-3.5,7.37-3.58,8.04-3.58h-1.93c-8.87,0-17.64,2.35-25.66,6.53   c-8.63,19.06-12.06,39.22-9.71,57.88c3.97,31.46,3.79,52.35-0.15,70.84c-3.46,16.26-8.94,28.39-11.96,34.42   C220.49,581.44,207.94,594.83,199.32,602.71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181769746647478740390000007187708864935438471_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.6998,
    y1: 241.4203,
    x2: 102.1531,
    y2: 364.7755,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "url(#SVGID_00000181769746647478740390000007187708864935438471_)"
    },
    d: "M319.73,392h33.02V337.2   c0-12.95-5.68-24.54-14.66-32.38c-7.37-6.43-16.96-10.33-27.44-10.33h-13.4C309.38,306.41,325.62,333.65,319.73,392z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013915989430971066350000007569473403778398908_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.5327,
    y1: 275.8107,
    x2: 87.8683,
    y2: 365.2325,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000013915989430971066350000007569473403778398908_)"
    },
    d: "M347.71,392h5.04V337.2   c0-12.95-5.68-24.54-14.66-32.38C343.8,319.3,349.58,345.69,347.71,392z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.146c89207ded143e1cbbb2f5c907042a.svg";
export { ForwardRef as ReactComponent };